import React from 'react';
import AdcDivider from '../ui/AdcDivider';

const Footer = () => {
  return (
    <footer id="aa-footer" className="bg-[#d0dae0] mt-16 px-[112px]">
      {/* Desktop Layout */}
      <div className="hidden md:block">
        <div className="max-w-7xl mx-auto px-6 py-8">
          <div className="grid grid-cols-4 gap-8 mb-8">
            {/* Help Section */}
            <div>
              <h2 className="text-base font-normal text-[#333] mb-3">Help</h2>
              <AdcDivider size="small" spacing="12" color="default" />
              <ul className="space-y-2">
                <li>
                  <a href="/i18n/customer-service/contact-american/american-customer-service.jsp" className="text-sm text-[#4a5568] hover:text-[#0078d4] hover:underline">
                    Contact American
                  </a>
                </li>
                <li>
                  <a href="/i18n/customer-service/contact-american/receipts-and-refunds.jsp" className="text-sm text-[#4a5568] hover:text-[#0078d4] hover:underline">
                    Receipts and refunds
                  </a>
                </li>
                <li>
                  <a href="/i18n/customer-service/faqs/faqs.jsp" className="text-sm text-[#4a5568] hover:text-[#0078d4] hover:underline">
                    FAQs
                  </a>
                </li>
                <li>
                  <a href="https://saleslink.aa.com/en-US/index.html#/home" target="_blank" rel="noopener noreferrer" className="text-sm text-[#4a5568] hover:text-[#0078d4] hover:underline flex items-center">
                    Agency reference
                    <svg className="w-3 h-3 ml-1" fill="currentColor" viewBox="0 0 12 12">
                      <path d="M10 0H2C.9 0 0 .9 0 2v8c0 1.1.9 2 2 2h3V9H2V2h8v3h3V2c0-1.1-.9-2-2-2zM8 6v2h2V6H8zm1 3v1h1V9H9z"/>
                    </svg>
                  </a>
                </li>
                <li>
                  <a href="https://www.aacargo.com/" target="_blank" rel="noopener noreferrer" className="text-sm text-[#4a5568] hover:text-[#0078d4] hover:underline flex items-center">
                    American Airlines Cargo
                    <svg className="w-3 h-3 ml-1" fill="currentColor" viewBox="0 0 12 12">
                      <path d="M10 0H2C.9 0 0 .9 0 2v8c0 1.1.9 2 2 2h3V9H2V2h8v3h3V2c0-1.1-.9-2-2-2zM8 6v2h2V6H8zm1 3v1h1V9H9z"/>
                    </svg>
                  </a>
                </li>
                <li>
                  <a href="/i18n/customer-service/support/optional-service-fees.jsp" className="text-sm text-[#4a5568] hover:text-[#0078d4] hover:underline">
                    Bag and optional fees
                  </a>
                </li>
                <li>
                  <a href="/i18n/customer-service/support/contingency-plans.jsp" className="text-sm text-[#4a5568] hover:text-[#0078d4] hover:underline">
                    Tarmac delay contingency plan
                  </a>
                </li>
                <li>
                  <a href="/i18n/customer-service/support/customer-service-plan.jsp" className="text-sm text-[#4a5568] hover:text-[#0078d4] hover:underline">
                    Customer service plan
                  </a>
                </li>
                <li>
                  <a href="/i18n/customer-service/support/conditions-of-carriage.jsp" className="text-sm text-[#4a5568] hover:text-[#0078d4] hover:underline">
                    Conditions of carriage
                  </a>
                </li>
              </ul>
            </div>

            {/* About American Section */}
            <div>
              <h2 className="text-base font-normal text-[#333] mb-3">About American</h2>
              <AdcDivider size="small" spacing="12" color="default" />
              <ul className="space-y-2">
                <li>
                  <a href="/i18n/customer-service/about-us/about-us.jsp" className="text-sm text-[#4a5568] hover:text-[#0078d4] hover:underline">
                    About us
                  </a>
                </li>
                <li>
                  <a href="https://jobs.aa.com/?utm_source=CorpSite&utm_campaign=aa.comownedchannel" target="_blank" rel="noopener noreferrer" className="text-sm text-[#4a5568] hover:text-[#0078d4] hover:underline flex items-center">
                    We're hiring! Join our team
                    <svg className="w-3 h-3 ml-1" fill="currentColor" viewBox="0 0 12 12">
                      <path d="M10 0H2C.9 0 0 .9 0 2v8c0 1.1.9 2 2 2h3V9H2V2h8v3h3V2c0-1.1-.9-2-2-2zM8 6v2h2V6H8zm1 3v1h1V9H9z"/>
                    </svg>
                  </a>
                </li>
                <li>
                  <a href="https://americanairlines.gcs-web.com/" target="_blank" rel="noopener noreferrer" className="text-sm text-[#4a5568] hover:text-[#0078d4] hover:underline flex items-center">
                    Investor relations
                    <svg className="w-3 h-3 ml-1" fill="currentColor" viewBox="0 0 12 12">
                      <path d="M10 0H2C.9 0 0 .9 0 2v8c0 1.1.9 2 2 2h3V9H2V2h8v3h3V2c0-1.1-.9-2-2-2zM8 6v2h2V6H8zm1 3v1h1V9H9z"/>
                    </svg>
                  </a>
                </li>
                <li>
                  <a href="https://news.aa.com/" target="_blank" rel="noopener noreferrer" className="text-sm text-[#4a5568] hover:text-[#0078d4] hover:underline flex items-center">
                    Newsroom
                    <svg className="w-3 h-3 ml-1" fill="currentColor" viewBox="0 0 12 12">
                      <path d="M10 0H2C.9 0 0 .9 0 2v8c0 1.1.9 2 2 2h3V9H2V2h8v3h3V2c0-1.1-.9-2-2-2zM8 6v2h2V6H8zm1 3v1h1V9H9z"/>
                    </svg>
                  </a>
                </li>
                <li>
                  <a href="/i18n/customer-service/support/legal-privacy-copyright.jsp" className="text-sm text-[#4a5568] hover:text-[#0078d4] hover:underline">
                    Legal, privacy, copyright
                  </a>
                </li>
                <li>
                  <a href="https://news.aa.com/esg/" target="_blank" rel="noopener noreferrer" className="text-sm text-[#4a5568] hover:text-[#0078d4] hover:underline flex items-center">
                    Environmental, social and governance
                    <svg className="w-3 h-3 ml-1" fill="currentColor" viewBox="0 0 12 12">
                      <path d="M10 0H2C.9 0 0 .9 0 2v8c0 1.1.9 2 2 2h3V9H2V2h8v3h3V2c0-1.1-.9-2-2-2zM8 6v2h2V6H8zm1 3v1h1V9H9z"/>
                    </svg>
                  </a>
                </li>
                <li>
                  <a href="/i18n/customer-service/about-us/combating-modern-slavery-human-trafficking.jsp" className="text-sm text-[#4a5568] hover:text-[#0078d4] hover:underline">
                    Modern Slavery Report
                  </a>
                </li>
                <li>
                  <a href="/i18n/customer-service/support/browser-compatibility.jsp" className="text-sm text-[#4a5568] hover:text-[#0078d4] hover:underline">
                    Browser compatibility
                  </a>
                </li>
                <li>
                  <a href="/i18n/customer-service/about-us/web-accessibility.jsp" className="text-sm text-[#4a5568] hover:text-[#0078d4] hover:underline">
                    Web accessibility
                  </a>
                </li>
              </ul>
            </div>

            {/* Extras Section */}
            <div>
              <h2 className="text-base font-normal text-[#333] mb-3">Extras</h2>
              <AdcDivider size="small" spacing="12" color="default" />
              <ul className="space-y-2">
                <li>
                  <a href="/i18n/customer-service/programs-products/business-travel-services.jsp" className="text-sm text-[#4a5568] hover:text-[#0078d4] hover:underline">
                    Business programs
                  </a>
                </li>
                <li>
                  <a href="https://giftcards.aa.com" target="_blank" rel="noopener noreferrer" className="text-sm text-[#4a5568] hover:text-[#0078d4] hover:underline flex items-center">
                    Gift cards
                    <svg className="w-3 h-3 ml-1" fill="currentColor" viewBox="0 0 12 12">
                      <path d="M10 0H2C.9 0 0 .9 0 2v8c0 1.1.9 2 2 2h3V9H2V2h8v3h3V2c0-1.1-.9-2-2-2zM8 6v2h2V6H8zm1 3v1h1V9H9z"/>
                    </svg>
                  </a>
                </li>
                <li>
                  <a href="/i18n/plan-travel/extras/trip-insurance.jsp" className="text-sm text-[#4a5568] hover:text-[#0078d4] hover:underline">
                    Trip insurance
                  </a>
                </li>
              </ul>
            </div>

            {/* Promotional Ads */}
            <div className="flex flex-col space-y-4">
              <a href="https://www.aa.com/aadvantage-program/buy-gift-transfer/en_US/home/buy?cint=DSP||20190919|BGT|ADV|FTR||HPFTR_BUY" target="_blank" rel="noopener noreferrer">
                <img 
                  src="https://www.aa.com/content/images/homepage/footer/en_US/footer-bgt-07012023.png" 
                  alt="Buy or gift miles for new adventures." 
                  className="w-full h-auto rounded"
                />
              </a>
              <a href="https://aadvantagecars.com/?clientID=399340" target="_blank" rel="noopener noreferrer">
                <img 
                  src="https://www.aa.com/content/images/homepage/footer/en_US/footer-avis-budget-07012025.png" 
                  alt="Save up to 35% and earn 500 bonus miles with Avis and Budget. Opens another site in a new window that may not meet accessibility guidelines" 
                  className="w-full h-auto rounded"
                />
              </a>
            </div>
          </div>

          {/* Divider */}
          <AdcDivider size="small" spacing="24" color="default" />

          {/* Bottom Section - Desktop */}
          <div className="flex justify-between items-start">
            <div className="flex-1">
              <div className="flex items-center text-xs text-[#666] mb-2">
                <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 12 12">
                  <path d="M10 0H2C.9 0 0 .9 0 2v8c0 1.1.9 2 2 2h3V9H2V2h8v3h3V2c0-1.1-.9-2-2-2zM8 6v2h2V6H8zm1 3v1h1V9H9z"/>
                </svg>
                Link opens in new window. Site may not meet accessibility guidelines. AA.com®
              </div>
            </div>
            <div className="flex items-center space-x-4">
              <div className="flex space-x-3">
                <a href="https://www.facebook.com/AmericanAirlines" target="_blank" rel="noopener noreferrer">
                  <img 
                    src="/content/images/homepage/footer/en_US/icon-facebook.png" 
                    alt="Follow us on Facebook" 
                    className="w-6 h-6"
                  />
                </a>
                <a href="https://www.youtube.com/americanairlines" target="_blank" rel="noopener noreferrer">
                  <img 
                    src="/content/images/homepage/footer/en_US/icon-youtube.png" 
                    alt="American Airlines YouTube channel" 
                    className="w-6 h-6"
                  />
                </a>
                <a href="https://twitter.com/americanair" target="_blank" rel="noopener noreferrer">
                  <img 
                    src="/content/images/homepage/footer/en_US/icon-twitter.png" 
                    alt="Follow us on X" 
                    className="w-6 h-6"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Layout */}
      <div className="block md:hidden">
        <div className="max-w-full mx-auto px-4 py-6">
          <div className="mb-6">
            <ul className="space-y-3">
              <li>
                <a href="/i18n/customer-service/contact-american/receipts-and-refunds.jsp" className="text-sm text-[#4a5568] hover:text-[#0078d4] hover:underline">
                  Receipts and refunds
                </a>
              </li>
              <li>
                <a href="/i18n/customer-service/support/optional-service-fees.jsp" className="text-sm text-[#4a5568] hover:text-[#0078d4] hover:underline">
                  Bag and optional fees
                </a>
              </li>
              <li>
                <a href="/i18n/customer-service/support/contingency-plans.jsp" className="text-sm text-[#4a5568] hover:text-[#0078d4] hover:underline">
                  Customer service and contingency plans
                </a>
              </li>
              <li>
                <a href="/i18n/customer-service/support/conditions-of-carriage.jsp" className="text-sm text-[#4a5568] hover:text-[#0078d4] hover:underline">
                  Conditions of carriage
                </a>
              </li>
              <li>
                <a href="/i18n/customer-service/faqs/faqs.jsp" className="text-sm text-[#4a5568] hover:text-[#0078d4] hover:underline">
                  FAQs
                </a>
              </li>
              <li>
                <a href="/i18n/customer-service/contact-american/american-customer-service.jsp" className="text-sm text-[#4a5568] hover:text-[#0078d4] hover:underline">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Divider */}
          <AdcDivider size="small" spacing="16" color="default" />

          {/* Bottom Section - Mobile */}
          <div className="flex justify-between items-center">
            <div className="flex-1">
              <div className="text-xs text-[#666] space-x-2">
                <a href="/i18n/customer-service/support/legal-privacy-copyright.jsp" className="text-[#4a5568] hover:text-[#0078d4] hover:underline">
                  Legal, privacy, copyright
                </a>
                <span>·</span>
                <a href="https://www.aa.com/i18n/travel-info/travel-tools/american-airlines-app.jsp" className="text-[#4a5568] hover:text-[#0078d4] hover:underline">
                  American app
                </a>
              </div>
            </div>
            <div className="flex items-center space-x-4">
              <a href="/i18n/travel-info/partner-airlines/oneworld-airline-partners.jsp" target="_blank" rel="noopener noreferrer">
                <img 
                  src="https://www.aa.com/content/images/icons-logos/logos/logo-oneworld.svg" 
                  alt="oneworld" 
                  className="h-5"
                />
              </a>
              <div className="flex space-x-2">
                <a href="https://www.facebook.com/AmericanAirlines" target="_blank" rel="noopener noreferrer">
                  <img 
                    src="https://www.aa.com/content/images/icons-logos/icons/icon-facebook.png" 
                    alt="Follow us on Facebook" 
                    className="w-5 h-5"
                  />
                </a>
                <a href="https://www.youtube.com/americanairlines" target="_blank" rel="noopener noreferrer">
                  <img 
                    src="https://www.aa.com/content/images/icons-logos/icons/icon-youtube.png" 
                    alt="American Airlines YouTube channel" 
                    className="w-5 h-5"
                  />
                </a>
                <a href="https://twitter.com/americanair" target="_blank" rel="noopener noreferrer">
                  <img 
                    src="https://www.aa.com/content/images/icons-logos/icons/icon-twitter.png" 
                    alt="Follow us on X" 
                    className="w-5 h-5"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
